import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
import content from './content'
import plans from './plans'
import settings from './settings'
import files from './files'
import availability from './availability'
import bookings from './bookings'
import schedules from './schedules'
import students from './students'
import messages from './messages'
import earnings from './earnings'
import connect from './connect'
import lessons from './lessons'
/**
* @see \App\Http\Controllers\DashboardController::dashboard
* @see app/Http/Controllers/DashboardController.php:46
* @route '/teacher/dashboard'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/teacher/dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DashboardController::dashboard
* @see app/Http/Controllers/DashboardController.php:46
* @route '/teacher/dashboard'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\DashboardController::dashboard
* @see app/Http/Controllers/DashboardController.php:46
* @route '/teacher/dashboard'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DashboardController::dashboard
* @see app/Http/Controllers/DashboardController.php:46
* @route '/teacher/dashboard'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

const teacher = {
    dashboard: Object.assign(dashboard, dashboard),
    content: Object.assign(content, content),
    plans: Object.assign(plans, plans),
    settings: Object.assign(settings, settings),
    files: Object.assign(files, files),
    availability: Object.assign(availability, availability),
    bookings: Object.assign(bookings, bookings),
    schedules: Object.assign(schedules, schedules),
    students: Object.assign(students, students),
    messages: Object.assign(messages, messages),
    earnings: Object.assign(earnings, earnings),
    connect: Object.assign(connect, connect),
    lessons: Object.assign(lessons, lessons),
}

export default teacher